import React from "react"

const ContentBody = props => (
  /**
    className="border-l-2 border-r-2 border-gray-200" */
  // max-w-4xl mx-auto
  <div
    className=" px-2 md:px-6 xl:px-12 py-4 md:py-6"
    style={{
      margin: `0 auto`,
      maxWidth: 1080,
      zIndex: "10",
    }}
  >
    {props.children}
  </div>
)

export default ContentBody
